import { useTranslation } from 'react-i18next';
import styles from './LoadingState.module.css';

interface LoadingStateProps {
  message?: string;
}

export const LoadingState = ({ message }: LoadingStateProps) => {
  const { t } = useTranslation();
  const resolvedMessage = message ?? t('common:loading');

  return (
    <div className={styles.container} role="status" aria-live="polite">
      <div className={styles.spinner} />
      <p className={styles.message}>{resolvedMessage}</p>
    </div>
  );
};
